import { render } from "./FormatSample.vue?vue&type=template&id=a496b926&scoped=true"
const script = {}

import "./FormatSample.vue?vue&type=style&index=0&id=a496b926&scoped=true&lang=css"

import exportComponent from "C:\\Users\\MORIMI\\Documents\\git_repositories\\heightlimit_mapbox\\heightlimit_mapbox\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a496b926"]])

export default __exports__